export const getRequiredEnvVariable = (key: string): string => {
  if (typeof process.env[key] === 'undefined') {
    throw new Error(`Variable ${key} is not set.`);
  }

  return process.env[key] as string;
};

export const getOptionalEnvVariable = (key: string): string | null => process.env[key] ?? null;
